"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useTheme.default;
  }
});

var _useTheme = _interopRequireDefault(require("./useTheme"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/styles/useTheme/index.js
 ** module id = 79
 ** module chunks = 0
 **/